module.exports = __webpack_public_path__ + "img/not-found-icon.11a1253d.svg";